import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import { RateActionTypes, RateActions } from "../../../actionTypes/master/rateActionTypes";
import { createRateApi, editRateDataByIdApi, getRateDataByIdApi, getRateListApi } from "../../requests/master/rateRequests";
import { getRateList, setRateDataById, setRateList, setRateListPageCount } from "../../../actions/master/rateActions";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";



function* getRateListHandler(action: RateActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getRateListApi, action.payload);
    if (data.status) {
      yield put(setRateList(data?.data?.rows));
      yield put(setRateListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* createRateHandler(action: RateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createRateApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getRateDataByIdHandler(action: RateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getRateDataByIdApi, action.payload);
    if (data.status) {
      yield put(setRateDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}
function* editRateDataByIdHandler(action: RateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editRateDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getRateList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// tat sagas
export default function* rateSaga() {
  yield takeLatest(RateActions.CREATE_RATE, createRateHandler);
  yield takeLatest(RateActions.GET_RATE_LIST, getRateListHandler);
  yield takeLatest(RateActions.GET_RATE_DATA_BY_ID, getRateDataByIdHandler);
  yield takeLatest(RateActions.EDIT_RATE_DATA_BY_ID, editRateDataByIdHandler);
}
